import { useEffect, useState } from "react";
import { pingHealth } from "./api";

type HealthState =
  | { status: "loading" }
  | { status: "ok"; service: string }
  | { status: "error"; message: string };

export function App() {
  const [health, setHealth] = useState<HealthState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    pingHealth()
      .then((body) => {
        if (!cancelled) setHealth({ status: "ok", service: body.service });
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setHealth({
            status: "error",
            message: err instanceof Error ? err.message : String(err),
          });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main
      style={{
        fontFamily: "system-ui, -apple-system, sans-serif",
        maxWidth: "42rem",
        margin: "4rem auto",
        padding: "0 1rem",
        lineHeight: 1.5,
      }}
    >
      <h1>Bersihir</h1>
      <p>Laundry, delivered. Beta scaffolding — real UX lives in PRs after this one.</p>

      <section>
        <h2 style={{ fontSize: "1rem" }}>API status</h2>
        {health.status === "loading" && <p>checking…</p>}
        {health.status === "ok" && <p>connected to <code>{health.service}</code>.</p>}
        {health.status === "error" && (
          <p style={{ color: "#b00020" }}>
            API unreachable: <code>{health.message}</code>
          </p>
        )}
      </section>
    </main>
  );
}
